import React, { useEffect } from 'react';
import './Toasts.scss';
import { useToastStore } from 'v2/store';
import { Close } from 'common/Icons/Icons';

const TOAST_TIMER = 3000;

const Toast = ({ id, children }: { id: string; children: React.ReactNode }) => {
  const { removeToast } = useToastStore();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(id);
    }, TOAST_TIMER);
    return () => {
      clearTimeout(timer);
    };
  }, [id, removeToast]);

  return (
    <div className="custom-toast">
      {children}
      <div
        className="custom-toast-close-button"
        onClick={() => removeToast(id)}
      >
        <Close height={'22px'} width={'22px'} fill="#8C8C8C" />
      </div>
    </div>
  );
};

const Toasts = () => {
  const { toasts } = useToastStore();

  return (
    <>
      {toasts.map(({ id, payload }) => (
        <Toast key={id} id={id}>
          {payload}
        </Toast>
      ))}
    </>
  );
};

export default Toasts;
